<div class="td-wb-radio">
  <input type="radio"
         class="td-wb-radio__input"
         [attr.id]="finalRadioId()"
         [name]="finalName()"
         [value]="value()"
         [attr.tabindex]="tabIndex()"
         [attr.aria-label]="ariaLabel()"
         [attr.aria-labelledby]="ariaLabelledBy()"
         [checked]="checked()"
         [disabled]="disabled()"
         (change)="onInputChange($event)"
         (click)="onInputClick($event)">
  <label class="td-wb-radio__label"
         [attr.for]="finalRadioId()">
    <span class="td-wb-radio__circle"
          [class.td-wb-radio__circle--center]="isSelectorCenter()"></span>
    <span class="td-wb-radio__label-content"
          [class.td-wb-radio__label-content--left]="isLabelLeft()">
         <ng-content />
      </span>
  </label>
</div>
